// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cu-b";
export var colorBlue = "_cu-8";
export var colorDot = "_cu-0";
export var colorDotLarge = "_cu-2";
export var colorDotSmall = "_cu-1";
export var colorGreen = "_cu-7";
export var colorGrey = "_cu-3";
export var colorOrange = "_cu-5";
export var colorPink = "_cu-a";
export var colorPurple = "_cu-9";
export var colorRed = "_cu-4";
export var colorYellow = "_cu-6";